export default {
    attach: function () { },
    detach: function () { },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/focus-lock/dist/es2015/tabHook.js
// module id = 394
// module chunks = 0